export default __webpack_public_path__ + "static/media/hotel1stfloormap.d7f9ac90.png";